import { createFeatureSelector, createSelector } from '@ngrx/store';

import { InstalledApplication } from '@era/locations-sdk';
import { DeviceConfiguredApplicationsStoreSelectors } from '../device-configured-applications-store';
import { ConfiguredApplication } from '../device-configured-applications-store/device-configured-applications.state';
import * as fromReducer from './device-installed-applications.reducer';
import { DeviceInstalledApplicationsState } from './device-installed-applications.state';

export const selectDeviceInstalledApplicationsState = createFeatureSelector<DeviceInstalledApplicationsState>(
  'device-installed-applications'
);

export const selectDeviceInstalledApplicationsIds = createSelector(
  selectDeviceInstalledApplicationsState,
  fromReducer.selectDeviceInstalledApplicationsIds
);

export const selectDeviceInstalledApplicationsEntities = createSelector(
  selectDeviceInstalledApplicationsState,
  fromReducer.selectDeviceInstalledApplicationsEntities
);

export const selectAllDeviceInstalledApplications = createSelector(
  selectDeviceInstalledApplicationsState,
  fromReducer.selectDeviceInstalledApplicationsStatuses
);

export const selectDeviceInstalledApplicationsByUdid = (udid: string) =>
  createSelector(
    selectAllDeviceInstalledApplications,
    (installedApplications: InstalledApplication[]): InstalledApplication[] => {
      return installedApplications.filter((x) => x.deviceId === udid);
    }
  );

// Returns true if all configured applications are installed on the device
export const selectConfiguredApplicationsAreInstalledByUdid = (udid: string) =>
  createSelector(
    DeviceConfiguredApplicationsStoreSelectors.selectDeviceConfiguredApplicationsByUdid(udid),
    selectDeviceInstalledApplicationsByUdid(udid),
    (configuredApplications: ConfiguredApplication[], installedApplications: InstalledApplication[]): boolean => {
      // Get a list of apps that are configured and that are installed
      const configured: string[] = configuredApplications.map(
        (x) => (x.bundleIdentifier ?? '') + (x.bundleVersion ?? '')
      );
      const installed: string[] = installedApplications.map(
        (x) => (x.bundleIdentifier ?? '') + (x.bundleVersion ?? '')
      );

      // Check if all configured apps are actually installed
      const installedContainsAllConfiguredApps = configured.every((x: string) => installed.includes(x));

      return installedContainsAllConfiguredApps;
    }
  );
